import styled from "styled-components";

const Form = styled.form`
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 500px;
  box-sizing: border-box;
`;

const Title = styled.h2`
  margin-bottom: 20px;
  color: #25d366;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

const Input = styled.input`
  width: 100%;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 15px;
  font-size: 18px;
  box-sizing: border-box;
  &:focus {
    border-color: #25d366;
  }
  &:focus-visible {
    border-color: transparent;
    outline-color: #25d366;
  }
`;

const InputWrapper = styled.div`
  margin-bottom: 15px;
`;

const Button = styled.button`
  width: 100%;
  padding: 10px;
  background-color: #25d366;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  border: 1px solid #25d366;
  cursor: pointer;
  transition: ease-in-out 0.3s;
  &:hover {
    background-color: transparent;
    color: #25d366;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
`;

const ModalContent = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  z-index: 1000;
  border-radius: 40px;
`;

const CloseButton = styled.button`
  position: absolute;
  color: #000;
  opacity: 0.5;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 35px;
  cursor: pointer;
  &:hover {
    color: #128c7e;
  }
`;

const RecaptchaWrapper = styled.div`
  margin-bottom: 15px;
`;

const ErrorShow = styled.div`
  margin-bottom: 0 !important;
  color: red;
`;

const Logo = styled.h1`
  color: #25d366;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const HeaderWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LeftBar = styled.div``;
const RightBar = styled.div`
  display: flex;
  gap: 20px;
`;

const LoginButton = styled.button`
  width: 100%;
  padding: 10px;
  color: #25d366;
  background-color: transparent;
  border: 1px solid #25d366;
  border-radius: 4px;
  cursor: pointer;
  transition: ease-in-out 0.3s;
  &:hover {
    background-color: #25d366;
    color: #ffffff;
  }
`;

const GroupButton = styled.div`
  display: flex;
  gap: 10px;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
`;

const ErrorModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1001;
`;

const ErrorModalContent = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  z-index: 1002;
  border-radius: 10px;
  width: 300px;
`;

const ErrorModalMessage = styled.p`
  color: red;
  text-align: center;
  font-size: 18px;
`;

const SuccessModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1001;
`;

const SuccessModalContent = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  z-index: 1002;
  border-radius: 10px;
  width: 300px;
`;

const SuccessModalMessage = styled.p`
  color: red;
  text-align: center;
  font-size: 18px;
`;

const ForgotLink = styled.a`
  display: block;
  text-align: center;
  color: #25d366;
  cursor: pointer;
  margin-top: 10px;
  text-decoration: underline;
  &:hover {
    color: #128c7e;
  }
`;
const AvatarWrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;

  img {
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  right: 0;
  background-color: white;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 100;
  border-radius: 8px;
  overflow: hidden;
  width: 170px;
`;

const DropdownItem = styled.div`
  padding: 10px 0px 5px 15px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }
`;

const Avatar = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  background-color: #25d366;
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  color: white;
`;
export {
  DropdownItem,
  DropdownMenu,
  AvatarWrapper,
  Form,
  Title,
  Input,
  Button,
  ModalOverlay,
  ModalContent,
  CloseButton,
  RecaptchaWrapper,
  ErrorShow,
  InputWrapper,
  Logo,
  HeaderWrapper,
  LeftBar,
  RightBar,
  LoginButton,
  GroupButton,
  ErrorModalOverlay,
  ErrorModalContent,
  ErrorModalMessage,
  SuccessModalOverlay,
  SuccessModalContent,
  SuccessModalMessage,
  ForgotLink,
  Avatar,
};
